import { ChangePasswordComponent } from './change-password.component';
import { connect } from 'react-redux';

export const ChangePassword = connect((state) => ({ sState: state }))(
  ChangePasswordComponent
);
